module.exports = __webpack_public_path__ + "static/media/clarkpark.6628e864.png";